(() => {
	'use strict';
	$('#tag-page-wrapper').on('click', '.pagination a', function (evt) {
		evt.preventDefault();
		window.ajaxNavigateTo(this.href, 'tag-page-artikel');
		return false;
	});
})();
